@if (showTaxation$ | async) {
    <span class="quick-bet__taxation-info-za--truncate">{{ taxationInfo }}</span>
}
